import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { BonusUi, Dropzone } from "../../../Constant";
import SingleFileUpload from "./SingleFileUpload";
import MultiFileUpload from "./MultiFileUpload";
import DefaultFileUpload from "./DefaultFileUpload";
import ImagePreviews from "./ImagePreview";

const DropzoneCintainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={Dropzone} parent={BonusUi} title={Dropzone} />
      <Container fluid>
        <Row>
          <DefaultFileUpload />
          <ImagePreviews />
          <SingleFileUpload />
          <MultiFileUpload />
        </Row>
      </Container>
    </>
  );
};

export default DropzoneCintainer;
